import { useContext, useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  InputLabel,
  MenuItem,
  Select,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import { isValidString } from "../../../Utils/validators";
import { useAppSelector } from "../../../Hooks/reduxHook";
import { Customer } from "Features/services/customer.api";
import { SnackBarContext } from "Context/SnackContext";
import { RootState } from "Features/store";
import { formatAsUsPhoneNo } from "Utils/transform";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import { LocalImage } from "Utils/images";
import { Colors } from "Utils/colors";
import { CustomInput, CustomRectangleButton } from "Components/Form";
import { addCustomerSchema } from "Schema";

interface Props {
  formType: "Add" | "Edit";
  initialValues: any;
  closeModal: (updateAPI?: boolean) => void;
}

const stateOptions: string[] = [
  "AL",
  "AK",
  "AZ",
  "AR",
  "CA",
  "CO",
  "CT",
  "DE",
  "DC",
  "FL",
  "GA",
  "HI",
  "ID",
  "IL",
  "IN",
  "IA",
  "KS",
  "KY",
  "LA",
  "ME",
  "MD",
  "MA",
  "MI",
  "MN",
  "MS",
  "MO",
  "MT",
  "NE",
  "NV",
  "NJ",
  "NM",
  "NY",
  "NC",
  "ND",
  "OH",
  "OK",
  "OR",
  "PA",
  "RI",
  "SC",
  "SD",
  "TN",
  "TX",
  "UT",
  "VT",
  "VA",
  "WA",
  "WV",
  "WI",
  "WY",
];

export default function AddCustomer({
  formType,
  initialValues,
  closeModal,
}: Props) {
  const access_token = useAppSelector(
    (state: RootState) => state.customer.access_token
  );

  const [isLoading, setIsLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const { handleSnackbar } = useContext(SnackBarContext);
  const [value, setValue] = useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  console.log("initialValues---", initialValues);

  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  const addCustomerForm = useFormik({
    initialValues,
    validationSchema: addCustomerSchema,
    validateOnChange: true,
    onSubmit: () => {},
  });

  const handleSubmit = (e: any) => {
    e.preventDefault();
    const values = addCustomerForm.values;
    addCustomerForm.submitForm();

    setTimeout(() => {
      if (addCustomerForm.isValid) {
        let payload: any;

        if (formType === "Add") {
          payload = {
            access_token: access_token,
            billingSameAsShipping: values.billingSameAsShipping,
            shipping_Name: values.shippingName,
            newCustomer: {
              BillAddr: {
                Line1: values.address,
                City: values.city,
                CountrySubDivisionCode: values.state,
                Country: values.country,
                PostalCode: values.zip,
              },
              ShipAddr: {
                Line1: values.shippingAddress || values.address,
                City: values.shippingCity || values.city,
                CountrySubDivisionCode: values.shippingState || values.state,
                // Country: values.shippingCountry || values.country,
                PostalCode: values.shippingZip || values.zip,
              },
              //CompanyName: values.CompanyName,
              DisplayName: values.DisplayName,
              PrimaryPhone: {
                FreeFormNumber:
                  formatAsUsPhoneNo(parseInt(values.phoneNo)) || values.phoneNo,
              },
              PrimaryEmailAddr: {
                Address: values.email,
              },
            },
            is_active: 1,
            total_credit_line: values.total_credit_line,
            credit_line_balance: values.credit_line_balance,
            company_name: values.company_name,
            customerType: values.customerType,
          };
        } else {
          payload = {
            access_token: access_token,
            billingSameAsShipping: values.billingSameAsShipping,
            shipping_Name: values.shippingName,
            newCustomer: {
              BillAddr: {
                Line1: values.address,
                City: values.city,
                CountrySubDivisionCode: values.state,
                Country: values.country,
                PostalCode: values.zip,
              },
              ShipAddr: {
                Line1: values.shippingAddress || values.address,
                City: values.shippingCity || values.city,
                CountrySubDivisionCode: values.shippingState || values.state,
                PostalCode: values.shippingZip || values.zip,
              },

              //CompanyName: values.CompanyName,
              SyncToken: values.SyncToken,
              DisplayName: values.DisplayName,
              PrimaryPhone: {
                FreeFormNumber:
                  formatAsUsPhoneNo(parseInt(values.phoneNo)) || values.phoneNo,
              },
              PrimaryEmailAddr: {
                Address: values.email,
              },
            },
            is_active: 1,
            total_credit_line: values.total_credit_line,
            credit_line_balance: values.credit_line_balance,
            qb_customer_id: initialValues.qb_customer_id,
            company_name: values.company_name,
            customerType: values.customerType,
          };
        }

        setErrorMsg("");
        setIsLoading(true);
        debugger;
        const action =
          formType === "Add"
            ? Customer.instance.addCustomer
            : Customer.instance.editCustomer;
        action(payload)
          .then((response) => {
            handleSnackbar(
              true,
              `Successfully ${formType === "Add" ? "Added" : "Edited"}`,
              "success"
            );
            closeModal(true);
          })
          .catch((error: any) => {
            const errorMessage = error?.response?.data?.message;
            setErrorMsg(errorMessage);
            handleSnackbar(true, errorMessage, "error");
          })
          .finally(() => {
            setIsLoading(false);
          });
      } else {
        handleSnackbar(true, "Please fix the missing fields", "error");
      }
    }, 200);
  };

  useEffect(() => {
    if (addCustomerForm.values.billingSameAsShipping) {
      addCustomerForm.setFieldValue(
        "shippingAddress",
        addCustomerForm.values.address
      );
      addCustomerForm.setFieldValue(
        "shippingCity",
        addCustomerForm.values.city
      );
      addCustomerForm.setFieldValue(
        "shippingState",
        addCustomerForm.values.state
      );
      addCustomerForm.setFieldValue("shippingZip", addCustomerForm.values.zip);
    }
  }, [
    addCustomerForm.values.billingSameAsShipping,
    addCustomerForm.values.address,
    addCustomerForm.values.city,
    addCustomerForm.values.state,
    addCustomerForm.values.zip,
  ]);

  console.log(
    "billingSameAsShipping--",
    addCustomerForm.values.billingSameAsShipping
  );

  return (
    <Box
      component="form"
      noValidate
      onSubmit={handleSubmit}
      sx={{
        width: "500px",
        margin: "0 auto",
        padding: "20px",
        boxSizing: "border-box",
      }}
    >
      <Box
        sx={{ width: "100%", height: "560px", overflowY: "hidden" }}
        className=""
      >
        <Grid rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid
            item
            xs={12}
            sm={12}
            md={8}
            lg={6}
            sx={{
              height: "auto",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
          >
            <Box>
              <Box sx={{ width: "100%" }}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  <Box
                    sx={{
                      position: "relative",
                      display: "inline-block",
                    }}
                  >
                    <Box
                      sx={{
                        border: "1px solid #ccc",
                        borderRadius: "50%",
                        marginBottom: "-16px",
                        backgroundColor: "#fff",
                        position: "relative",
                      }}
                    >
                      <img
                        src={LocalImage.companyLogo}
                        alt="Company Logo"
                        style={{
                          width: "75px",
                          height: "75px",
                          display: "block",
                        }}
                      />
                    </Box>

                    <Box
                      sx={{
                        borderRadius: "50%",
                        border: "1px solid #FFAA2A",
                        padding: "4px",
                        backgroundColor: "#fff",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        position: "absolute",
                        top: "50px",
                        left: "50px",
                      }}
                    >
                      <CameraAltIcon
                        sx={{ fontSize: "16px", color: "#FFAA2A" }}
                      />
                    </Box>
                  </Box>

                  <Box sx={{ marginLeft: "12px" }}>
                    {/* <Typography variant='body1' component={'body'} fontSize={'12px'}>
                      Edit Client Profile
                    </Typography> */}
                    <Typography
                      variant="h4"
                      fontWeight={"bold"}
                      component={"h4"}
                      color={Colors.primary}
                      fontSize={"22px"}
                    >
                      Fusion Link
                    </Typography>
                  </Box>
                </Box>
              </Box>

              <Box sx={{ border: `2px solid ${Colors.primary}` }} />
              <Box sx={{ border: `6px solid #A3CEDC` }} />

              <Box sx={{ width: "100%" }}>
                <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                  <Tabs
                    value={value}
                    onChange={handleChange}
                    aria-label="basic tabs example"
                  >
                    <Tab
                      label="Billing Information"
                      {...a11yProps(0)}
                      sx={{
                        fontSize: "12px",
                        textTransform: "capitalize",
                        color: Colors.primary,
                      }}
                    />
                    <Tab
                      label="Shipping Information"
                      {...a11yProps(1)}
                      sx={{
                        fontSize: "12px",
                        textTransform: "capitalize",
                        color: Colors.primary,
                      }}
                    />
                    <Tab
                      label="Credit Information"
                      {...a11yProps(2)}
                      sx={{
                        fontSize: "12px",
                        textTransform: "capitalize",
                        color: Colors.primary,
                      }}
                    />
                  </Tabs>
                </Box>

                <Box sx={{ m: 1, mt: 2 }}>
                  <div
                    role="tabpanel"
                    hidden={value !== 0}
                    id={`simple-tabpanel-0`}
                    aria-labelledby={`simple-tab-0`}
                  >
                    <Box>
                      <CustomInput
                        value={addCustomerForm.values.DisplayName}
                        onChangeText={(value) =>
                          addCustomerForm.setFieldValue("DisplayName", value)
                        }
                        errorMessage={
                          addCustomerForm.errors.DisplayName as string
                        }
                        isError={
                          (isValidString(addCustomerForm.errors.DisplayName) &&
                            addCustomerForm.touched.DisplayName) ||
                          false
                        }
                        handleBlur={addCustomerForm.handleBlur("DisplayName")}
                        label="Display Name*"
                        placeholder="John Doe"
                        size="small"
                        required={true}
                        containerStyle={{ marginTop: "5px", mb: "2px" }}
                        labelStyle={{ fontWeight: 400, color: "#666666" }}
                      />
                    </Box>

                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginTop: "-4px",
                      }}
                    >
                      <CustomInput
                        value={addCustomerForm.values.company_name}
                        onChangeText={(value) =>
                          addCustomerForm.setFieldValue("company_name", value)
                        }
                        errorMessage={
                          addCustomerForm.errors.company_name as string
                        }
                        isError={
                          (isValidString(addCustomerForm.errors.company_name) &&
                            addCustomerForm.touched.email) ||
                          false
                        }
                        handleBlur={addCustomerForm.handleBlur("company_name")}
                        label="Company Name"
                        placeholder="Company Name"
                        size="small"
                        required={true}
                        containerStyle={{
                          flex: 0.8,
                          marginRight: "16px",
                          marginTop: 1,
                        }}
                        labelStyle={{ fontWeight: 400, color: "#666666" }}
                      />

                      <Box sx={{ flex: 1, mt: "4px" }}>
                        <InputLabel
                          sx={{
                            fontSize: 12,
                            mb: "2px",
                            color: "#666666",
                            fontWeight: 400,
                          }}
                        >
                          Customer Type
                        </InputLabel>
                        <Select
                          labelId="demo-select-small-label"
                          id="demo-select-small"
                          inputProps={{ "aria-label": "Without label" }}
                          value={addCustomerForm.values.customerType}
                          onChange={(e) => {
                            addCustomerForm.setFieldValue(
                              "customerType",
                              e.target.value
                            );
                          }}
                          fullWidth
                          size="small"
                          placeholder="Customer Type"
                          sx={{ mt: 0.5, pb: 0.2, height: "32px" }}
                        >
                          <MenuItem value={"Retail"}>Retail</MenuItem>
                          <MenuItem value={"Wholesale"}>Wholesale</MenuItem>
                          <MenuItem value={"In_House"}>In House</MenuItem>
                        </Select>
                      </Box>
                    </Box>

                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginTop: "-4px",
                      }}
                    >
                      <CustomInput
                        value={addCustomerForm.values.email}
                        onChangeText={(value) =>
                          addCustomerForm.setFieldValue("email", value)
                        }
                        errorMessage={addCustomerForm.errors.email as string}
                        isError={
                          (isValidString(addCustomerForm.errors.email) &&
                            addCustomerForm.touched.email) ||
                          false
                        }
                        handleBlur={addCustomerForm.handleBlur("email")}
                        label="Email*"
                        placeholder="example@example.com"
                        size="small"
                        required={true}
                        containerStyle={{
                          flex: 0.8,
                          marginRight: "16px",
                          marginTop: 1,
                        }}
                        labelStyle={{ fontWeight: 400, color: "#666666" }}
                      />

                      <CustomInput
                        value={addCustomerForm.values.phoneNo}
                        onChangeText={(value) =>
                          addCustomerForm.setFieldValue("phoneNo", value)
                        }
                        errorMessage={addCustomerForm.errors.phoneNo as string}
                        isError={
                          (isValidString(addCustomerForm.errors.phoneNo) &&
                            addCustomerForm.touched.phoneNo) ||
                          false
                        }
                        handleBlur={addCustomerForm.handleBlur("phoneNo")}
                        label="Phone*"
                        placeholder="(774)-222-2390"
                        size="small"
                        required={true}
                        containerStyle={{ flex: 0.8, marginTop: 1 }}
                        labelStyle={{ fontWeight: 400, color: "#666666" }}
                      />
                    </Box>

                    <Box sx={{ marginTop: "5px" }}>
                      <CustomInput
                        value={addCustomerForm.values.address}
                        onChangeText={(value) =>
                          addCustomerForm.setFieldValue("address", value)
                        }
                        errorMessage={addCustomerForm.errors.address as string}
                        isError={
                          (isValidString(addCustomerForm.errors.address) &&
                            addCustomerForm.touched.address) ||
                          false
                        }
                        handleBlur={addCustomerForm.handleBlur("address")}
                        label="Address*"
                        placeholder="123 Seasame st."
                        size="small"
                        required={true}
                        containerStyle={{ flex: 0.8, marginTop: 1 }}
                        labelStyle={{ fontWeight: 400, color: "#666666" }}
                      />
                    </Box>

                    <Box
                      style={{
                        display: "flex",
                        gap: "5px",
                        justifyContent: "space-between",
                        marginTop: "-8px",
                      }}
                    >
                      <CustomInput
                        value={addCustomerForm.values.city}
                        onChangeText={(value) => {
                          addCustomerForm.setFieldValue("city", value);
                        }}
                        errorMessage={addCustomerForm.errors.city as string}
                        isError={
                          (isValidString(addCustomerForm.errors.city) &&
                            addCustomerForm.touched.city) ||
                          false
                        }
                        handleBlur={addCustomerForm.handleBlur("city")}
                        required={false}
                        label="City*"
                        placeholder="Shrewsbury"
                        size="small"
                        containerStyle={{ flex: 0.8 }}
                        labelStyle={{ fontWeight: 400, color: "#666666" }}
                      />

                      <Box sx={{ flex: 0.5, margin: "14px 4px 0px" }}>
                        <InputLabel
                          sx={{
                            fontSize: 12,
                            mb: "2px",
                            color: "#666666",
                            fontWeight: 400,
                          }}
                        >
                          State*
                        </InputLabel>
                        <Select
                          labelId="demo-select-small-label"
                          id="demo-select-small"
                          value={addCustomerForm.values.state || ""}
                          inputProps={{ "aria-label": "Without label" }}
                          onChange={(e) => {
                            addCustomerForm.setFieldValue(
                              "state",
                              e.target.value
                            );
                          }}
                          fullWidth
                          size="small"
                          placeholder="MA"
                          sx={{ mt: 0.5, pb: 0.2, height: "32px" }}
                        >
                          {stateOptions.map((state) => (
                            <MenuItem key={state} value={state}>
                              {state}
                            </MenuItem>
                          ))}
                        </Select>
                      </Box>

                      <CustomInput
                        value={addCustomerForm.values.zip}
                        onChangeText={(value) => {
                          addCustomerForm.setFieldValue("zip", value);
                        }}
                        errorMessage={addCustomerForm.errors.zip as string}
                        isError={
                          (isValidString(addCustomerForm.errors.zip) &&
                            addCustomerForm.touched.shippingZip) ||
                          false
                        }
                        handleBlur={addCustomerForm.handleBlur("shippingZip")}
                        required={false}
                        label="Zipcode*"
                        placeholder="01545"
                        size="small"
                        containerStyle={{ flex: 0.8 }}
                        labelStyle={{ fontWeight: 400, color: "#666666" }}
                      />
                    </Box>

                    <CustomInput
                      value={addCustomerForm.values.country}
                      onChangeText={(value) =>
                        addCustomerForm.setFieldValue("country", value)
                      }
                      errorMessage={addCustomerForm.errors.country as string}
                      isError={
                        (isValidString(addCustomerForm.errors.country) &&
                          addCustomerForm.touched.country) ||
                        false
                      }
                      handleBlur={addCustomerForm.handleBlur("country")}
                      label="Country*"
                      placeholder="Shrewsbury"
                      size="small"
                      required={true}
                      containerStyle={{ flex: 0.8, marginTop: 1 }}
                      labelStyle={{ fontWeight: 400, color: "#666666" }}
                    />
                  </div>

                  <div
                    role="tabpanel"
                    hidden={value !== 1}
                    id={`simple-tabpanel-1`}
                    aria-labelledby={`simple-tab-1`}
                  >
                    <Box>
                      <FormGroup className="checkbox-label-text">
                        <FormControlLabel
                          control={
                            <Checkbox
                              size="small"
                              checked={
                                addCustomerForm.values.billingSameAsShipping
                              }
                              onChange={(e, checked) => {
                                addCustomerForm.setFieldValue(
                                  "billingSameAsShipping",
                                  checked
                                );

                                if (checked) {
                                  addCustomerForm.setFieldValue(
                                    "shippingAddress",
                                    addCustomerForm.values.address
                                  );
                                  addCustomerForm.setFieldValue(
                                    "shippingCity",
                                    addCustomerForm.values.city
                                  );
                                  addCustomerForm.setFieldValue(
                                    "shippingState",
                                    addCustomerForm.values.state
                                  );
                                  addCustomerForm.setFieldValue(
                                    "shippingZip",
                                    addCustomerForm.values.zip
                                  );
                                }
                              }}
                            />
                          }
                          label="Shipping Address is same as Billing Address"
                        />
                      </FormGroup>

                      <CustomInput
                        value={addCustomerForm.values.shippingName}
                        onChangeText={(value) => {
                          addCustomerForm.setFieldValue("shippingName", value);
                        }}
                        errorMessage={
                          addCustomerForm.errors.shippingName as string
                        }
                        isError={
                          (isValidString(addCustomerForm.errors.shippingName) &&
                            addCustomerForm.touched.shippingName) ||
                          false
                        }
                        handleBlur={addCustomerForm.handleBlur("shippingName")}
                        required={false}
                        label="Shipping Name*"
                        placeholder="Shipping Name"
                        size="small"
                        labelStyle={{ fontWeight: 400, color: "#666666" }}
                      />

                      <Box sx={{ marginTop: "10px" }}>
                        <CustomInput
                          value={addCustomerForm.values.shippingAddress || ""}
                          onChangeText={(value) =>
                            addCustomerForm.setFieldValue(
                              "shippingAddress",
                              value
                            )
                          }
                          errorMessage={
                            addCustomerForm.errors.shippingAddress as string
                          }
                          isError={
                            (isValidString(
                              addCustomerForm.errors.shippingAddress
                            ) &&
                              addCustomerForm.touched.shippingAddress) ||
                            false
                          }
                          handleBlur={addCustomerForm.handleBlur(
                            "shippingAddress"
                          )}
                          label="Address*"
                          placeholder="123 Elm St."
                          size="small"
                          required={true}
                          containerStyle={{ flex: 0.8, marginTop: 1 }}
                          labelStyle={{ fontWeight: 400, color: "#666666" }}
                          disabled={
                            addCustomerForm.values.billingSameAsShipping
                          }
                        />
                      </Box>

                      <Box
                        style={{
                          display: "flex",
                          gap: "5px",
                          justifyContent: "space-between",
                          marginTop: "-8px",
                        }}
                      >
                        <CustomInput
                          value={addCustomerForm.values.shippingCity}
                          onChangeText={(value) => {
                            addCustomerForm.setFieldValue(
                              "shippingCity",
                              value
                            );
                          }}
                          errorMessage={
                            addCustomerForm.errors.shippingCity as string
                          }
                          isError={
                            (isValidString(
                              addCustomerForm.errors.shippingCity
                            ) &&
                              addCustomerForm.touched.shippingCity) ||
                            false
                          }
                          handleBlur={addCustomerForm.handleBlur(
                            "shippingCity"
                          )}
                          required={false}
                          label="City*"
                          placeholder="Shrewsbury"
                          size="small"
                          containerStyle={{ flex: 0.8 }}
                          labelStyle={{ fontWeight: 400, color: "#666666" }}
                          disabled={
                            addCustomerForm.values.billingSameAsShipping
                          }
                        />

                        <Box sx={{ flex: 0.5, margin: "14px 4px 0px" }}>
                          <InputLabel
                            sx={{
                              fontSize: 12,
                              mb: "2px",
                              color: "#666666",
                              fontWeight: 400,
                            }}
                          >
                            State*
                          </InputLabel>
                          <Select
                            labelId="demo-select-small-label"
                            id="demo-select-small"
                            value={addCustomerForm.values.shippingState || ""}
                            inputProps={{ "aria-label": "Without label" }}
                            onChange={(e) => {
                              addCustomerForm.setFieldValue(
                                "shippingState",
                                e.target.value
                              );
                            }}
                            fullWidth
                            size="small"
                            placeholder="MA"
                            sx={{ mt: 0.5, pb: 0.2, height: "32px" }}
                            disabled={
                              addCustomerForm.values.billingSameAsShipping
                            }
                          >
                            {stateOptions.map((state) => (
                              <MenuItem key={state} value={state}>
                                {state}
                              </MenuItem>
                            ))}
                          </Select>
                        </Box>

                        <CustomInput
                          value={addCustomerForm.values.shippingZip}
                          onChangeText={(value) => {
                            addCustomerForm.setFieldValue("shippingZip", value);
                          }}
                          errorMessage={
                            addCustomerForm.errors.shippingZip as string
                          }
                          isError={
                            (isValidString(
                              addCustomerForm.errors.shippingZip
                            ) &&
                              addCustomerForm.touched.shippingZip) ||
                            false
                          }
                          handleBlur={addCustomerForm.handleBlur("shippingZip")}
                          required={false}
                          label="Zipcode*"
                          placeholder="01545"
                          size="small"
                          containerStyle={{ flex: 0.8 }}
                          labelStyle={{ fontWeight: 400, color: "#666666" }}
                          disabled={
                            addCustomerForm.values.billingSameAsShipping
                          }
                        />
                      </Box>
                    </Box>
                  </div>

                  <div
                    role="tabpanel"
                    hidden={value !== 2}
                    id={`simple-tabpanel-2`}
                    aria-labelledby={`simple-tab-2`}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginTop: "-4px",
                      }}
                    >
                      <CustomInput
                        value={addCustomerForm.values.credit_line_balance}
                        onChangeText={(value) =>
                          addCustomerForm.setFieldValue(
                            "credit_line_balance",
                            value
                          )
                        }
                        errorMessage={
                          addCustomerForm.errors.credit_line_balance as string
                        }
                        isError={
                          (isValidString(
                            addCustomerForm.errors.credit_line_balance
                          ) &&
                            addCustomerForm.touched.credit_line_balance) ||
                          false
                        }
                        handleBlur={addCustomerForm.handleBlur(
                          "credit_line_balance"
                        )}
                        label="Creditline Balance*"
                        placeholder="Enter credit-balance"
                        size="small"
                        required={true}
                        containerStyle={{
                          flex: 0.8,
                          marginRight: "16px",
                          marginTop: 1,
                        }}
                        labelStyle={{ fontWeight: 400, color: "#666666" }}
                        type="number"
                      />

                      <CustomInput
                        value={addCustomerForm.values.total_credit_line}
                        onChangeText={(value) =>
                          addCustomerForm.setFieldValue(
                            "total_credit_line",
                            value
                          )
                        }
                        errorMessage={
                          addCustomerForm.errors.total_credit_line as string
                        }
                        isError={
                          (isValidString(
                            addCustomerForm.errors.total_credit_line
                          ) &&
                            addCustomerForm.touched.total_credit_line) ||
                          false
                        }
                        handleBlur={addCustomerForm.handleBlur(
                          "total_credit_line"
                        )}
                        label="Total Credit Line*"
                        placeholder="Enter total-credit-line"
                        size="small"
                        required={true}
                        containerStyle={{ flex: 0.8, marginTop: 1 }}
                        labelStyle={{ fontWeight: 400, color: "#666666" }}
                        type="number"
                      />
                    </Box>
                  </div>
                </Box>
              </Box>
            </Box>
            <Box
              sx={{
                mt: 0.5,
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end",
                alignItems: "center",
              }}
            >
              <CustomRectangleButton
                label={"Clear"}
                variant={"outlined"}
                labelColor="#FFAA2A"
                buttonContainerStyle={{
                  border: "1px solid #FFAA2A",
                  fontWeight: 700,
                }}
                onBtnClick={() => {}}
                uppercase={false}
                buttonnSize={"sm"}
              />

              <CustomRectangleButton
                label={formType === "Add" ? "Send" : "Update"}
                variant={"outlined"}
                labelColor="#fff"
                buttonColor="#FFAA2A"
                buttonContainerStyle={{
                  border: "1px solid #FFAA2A",
                  fontWeight: 700,
                  marginLeft: "20px",
                }}
                onBtnClick={handleSubmit}
                uppercase={false}
                buttonnSize={"sm"}
              />
            </Box>
          </Grid>
        </Grid>
        {/* 
        {isValidString(errorMsg) ? (
          <Typography variant="body1" component={"body"} color={"red"}>
            {errorMsg}
          </Typography>
        ) : null} */}
      </Box>
    </Box>
  );
}
